<template>
  <div
    id="skewContainer"
    class="relative aspect-square h-full max-h-[16rem] w-full max-w-[16rem] shrink-0 rotate-1 overflow-hidden rounded-3xl shadow-md [backface-visibility:hidden] md:max-h-[22rem] md:max-w-[22rem] lg:max-h-[26rem] lg:max-w-[26rem]"
    :class="{
      'before:pointer-events-none before:absolute before:inset-0 before:block before:h-full before:w-full before:bg-gradient-to-b before:from-transparent before:via-jag-950/0 before:to-jag-950/80 before:to-80% before:mix-blend-multiply':
        hasGradient,
    }"
  >
    <img :src="imgSrc" :alt="imgAlt ?? ''" class="h-full w-full object-cover" />

    <div
      v-if="label"
      class="absolute inset-0 flex items-end justify-center px-4 py-8 md:px-12 md:py-8"
    >
      <span
        class="nimpkish text-center text-2xl lg:text-4xl"
        :class="[lemon ? 'text-lemon-200' : 'text-white', textSize]"
        v-html="label"
      ></span>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  imgSrc: string;
  imgAlt?: string;
  label?: string;
  textSize?: string;
  lemon?: boolean;
  gradientOverlay?: boolean;
}>();

const hasGradient = computed(() => props.gradientOverlay || !!props.label);
</script>
